import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function BackToMore() {
  return (
    <Link
      to="/more"
      data-testid="back-to-more"
      className="inline-flex items-center mb-3"
      style={{ color: "#145261", fontSize: 15, fontWeight: 600 }}
    >
      <ChevronLeft size={20} color="#145261" strokeWidth={2.2} />
      <span style={{ marginLeft: 2 }}>More</span>
    </Link>
  );
}
